module.exports = __webpack_public_path__ + "img/tribaldex-logo.b5621181.png";